<template>
    <ul class="" >
        <li class="payouts__row" >
            <span class="payouts__name payouts__name--title" >
                {{ $t('payoutsName') }}
            </span>
            <span class="payouts__payout payouts__payout--title">
                {{ $t('payoutsValue') }}
            </span>
        </li>
        <!-- ↑标题 -->
        <!-- ↓内容 -->
        <li v-for="(cur,idx) of aThePayoutsList"
            :key="idx"
            class="payouts__row"
        >
            <span class="payouts__name">
                {{ $t(`roulette.${cur.i18n}`) }}
                <template v-if="$t(`roulette.${cur.desc}`)">
                    ({{ $t(`roulette.${cur.desc}`) }})
                </template>
            </span>
            <span class="payouts__payout">
                {{ cur.value }}
            </span>
        </li>
    </ul>
</template>

<script lang="ts" setup>
import {aPayouts} from '@/pages/casino/rouletteGame/js/rouletteData';
import {fnGetRouletteConfig } from '~/pages/casino/rouletteGame/js/rouletteFn'; 

const aThePayoutsList = ref(deepCopy(aPayouts));

onMounted(async ()=>{
    const oConfig = await fnGetRouletteConfig();
    const {coefficients} = oConfig?.['config'] || {};
    if (!coefficients) return;
    aThePayoutsList.value.forEach(cur=>{
        const multi = coefficients[cur.match];
        if (multi){
            cur.value = `x${multi}`;
        }
    });
    // console.log('roulette 游戏配置', deepCopy(coefficients)); 
});

</script>

<style scoped lang="scss">

.payouts__row {
    align-items: center;
    border-bottom: 1px solid #1c2532;
    display: flex;
    justify-content: space-between;
    padding: 12px 0
}

.payouts__row--title {
    padding: 0 0 9px
}

.payouts__row:last-child {
    border: none
}

.payouts__name,
.payouts__payout {
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.24px;
    line-height: 130%;
    margin-bottom: 0
}

.payouts__name--title,
.payouts__payout--title {
    color: #55657e;
    font-size: 11px;
    letter-spacing: -.22px;
    line-height: 135%
}

.payouts__payout {
    width: 50px
}


</style>


